import React, { useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { BiChevronRight } from "react-icons/bi";
import iconDashboard from "../../../assets/images/menu-icon/icon-dashboard.svg";
import iconInfo from "../../../assets/images/menu-icon/info-icon.svg";
import iconPortfolio from "../../../assets/images/menu-icon/portfolio-icon.svg";
import iconGolas from "../../../assets/images/menu-icon/goals-icon.svg";
import iconinsurance from "../../../assets/images/menu-icon/insurance.svg";
import iconAction from "../../../assets/images/menu-icon/action-icon.svg";
import iconPlaning from "../../../assets/images/menu-icon/planing-icon.svg";
import iconMisReport from "../../../assets/images/menu-icon/mis-report-icon.svg";
import iconExpenses from "../../../assets/images/menu-icon/expenses-icon.svg";
import iconAccounting from "../../../assets/images/Accounting.svg";
import iconFinancialPlaning from "../../../assets/images/Planning.svg";
import iconMaster from "../../../assets/images/Masters.svg";
import iconBd from "../../../assets/images/BD.svg";
import iconHr from "../../../assets/images/HR.svg";
import iconOperation from "../../../assets/images/Operations.svg";
import { Dispatch } from "redux";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { Disclosure } from "@headlessui/react";
import {
  ADMIN_INVOICE_TAB,
  SENT_FOR_REVIEW_TAB,
  MANAGER_TAB,
  COMPANY_MASTER_TAB,
  ADMIN_ASSIGN_TASK_TAB,
  ADVICE_LOG_BOOK,
  ADMIN_MY_TASK_TAB,
  SYSTEMATIC_PLAN_TAB,
  setDataInRedux,
  SHARE_TAB,
} from "../../../actions/CommonAction";
import WebService from "../../../utility/WebService";

// const navigationClient = [
//   {
//     name: "Dashboard",
//     icon: BiBarChartAlt2,
//     href: "/dashboard",
//     img: iconDashboard,
//   },
//   {
//     name: "Information",
//     icon: GrStatusInfo,
//     img: iconInfo,
//     current: false,
//     children: [
//       {
//         name: "Personal",
//         icon: BsPiggyBank,
//         href: "#",
//         values: [
//           { name: "Family", href: "/information/personal/family" },
//           { name: "Occupation", href: "/information/personal/occupation" },
//           {
//             name: "Health & Lifestyle",
//             href: "/information/personal/health-lifestyle",
//           },
//           { name: "Addresses", href: "/information/personal/address" },
//         ],
//       },
//       {
//         name: "Physical Assets",
//         icon: BsPiggyBank,
//         href: "#",
//         values: [
//           { name: "Vehicles", href: "/information/physical-assets/vehicles" },
//           { name: "Household", href: "/information/physical-assets/household" },
//         ],
//       },
//       { name: "Accounts", href: "/information/accounts" },
//       { name: "Income", href: "/information/income" },
//       { name: "Loans", href: "/information/loans" },
//       // { name: "Expense Vouchers", href: "information/expense-vouchers" },
//     ],
//   },
//   {
//     name: "Portfolio",
//     icon: BsPiggyBank,
//     href: "/portfolio",
//     img: iconPortfolio,
//     removeKey: "SYSTEMATIC_PLAN_TAB",
//   },
//   { name: "Goals", icon: GrTarget, href: "/goals", img: iconGolas },
//   { name: "Expenses", icon: GrTarget, href: "/expenses", img: iconExpenses },
//   {
//     name: "Insurance",
//     icon: BsUmbrellaFill,
//     href: "/insurance",
//     img: iconinsurance,
//   },

//   {
//     name: "Actions",
//     icon: BsFileEarmarkBarGraph,
//     img: iconAction,
//     href: "",
//     current: false,
//     children: [
//       { name: "Tasks", href: "/actions" },
//       { name: "Minutes of Meeting", href: "/action/minutes-of-meeting" },
//       { name: "Raise Advice Request", href: "#" },
//     ],
//   },
//   {
//     name: "Planning",
//     img: iconPlaning,
//     icon: BsCalendar2Plus,
//     current: false,
//     children: [
//       { name: "Life insurance", href: "/planing/life-insrance-requirement" },
//       { name: "Retirement", href: "/planing/retirement" },
//     ],
//   },
//   {
//     name: "MIS Reports",
//     icon: BsFileEarmarkBarGraph,
//     img: iconMisReport,
//     href: "/reports",
//     current: false,
//     // children: [
//     //   { name: 'MF Transaction Report', href: '#' },
//     //   { name: 'Capital Gain', href: '#' },
//     //   { name: 'Transactions', href: '#' },
//     //   { name: 'Tax Calculations', href: '#' },
//     //   { name: 'Invoices', href: '#' },
//     // ],
//   },
// ];

// // Super Admin

// const navigationSuperAdmin = [
//   {
//     name: "Dashboard",
//     icon: BiBarChartAlt2,
//     href: "/dashboard",
//     img: iconDashboard,
//   },
//   {
//     name: "Masters",
//     icon: GrStatusInfo,
//     img: iconInfo,
//     current: false,
//     children: [
//       { name: "Company Details", href: "/company-master" },
//       { name: "Advisors", href: "/master/adviosr" },
//       { name: "Mail Templates", href: "/mail-template" },
//       { name: "Assumptions Master", href: "/assumption-master" },
//       { name: "Menu Organizer", href: "/master/menu-organizer" },
//       { name: "Role Managment", href: "/role-management-permission" },
//       { name: "Upload Document", href: "" },
//       {
//         name: "Advisor Goals Master",
//         icon: BsPiggyBank,
//         href: "/goalliablities/goal-liablities",
//         // img: iconDashboard,
//       },
//       {
//         name: "Help",
//         icon: BsPiggyBank,
//         href: "#",
//         values: [
//           { name: "Help Master", href: "" },
//           { name: "Client Help Master", href: "" },
//           { name: "Financial Planning Help Master", href: "" },
//         ],
//       },
//       {
//         name: "Accounting Master",
//         icon: BsPiggyBank,
//         href: "#",
//         values: [
//           { name: "Financial Year", href: "/accouting-master/financial-year" },
//           {
//             name: "Cost Inflation Index (CII)",
//             href: "/accouting-master/cost-Inflation",
//           },
//           { name: "GST Master", href: "/accouting-master/gst-master" },
//         ],
//       },
//       { name: "Document Master", href: "" },
//     ],
//   },
//   {
//     name: "Product Master",
//     icon: GrStatusInfo,
//     img: iconInfo,
//     current: false,
//     children: [
//       {
//         name: "Client Portfolio Master",
//         href: "product-master/client-portfolio",
//       },
//       { name: "Product Categories", href: "/information/product-categories" },
//       {
//         name: "Insurance",
//         icon: BsPiggyBank,
//         href: "#",
//         values: [
//           { name: "Types", href: "/insurance/types" },
//           { name: "Sub Types", href: "/insurance/subTypes" },
//           { name: "Benefits Available", href: "/insurance/benifits-available" },
//           { name: "Nature of Policy", href: "/insurance/natureof-policy" },
//           { name: "Riders", href: "/insurance/riders" },
//           { name: "Categories", href: "/insurance/categories" },
//           { name: "Annuity Types", href: "/insurance/annuity-types" },
//         ],
//       },
//       { name: "Transactions Type", href: "/insurance/transactions-type" },
//       {
//         name: "Mutual Funds",
//         icon: BsPiggyBank,
//         href: "#",
//         values: [
//           { name: "Taxation", href: "/mutualfunds/taxaction" },
//           { name: "Categories", href: "/mutualfunds/categories" },
//           { name: "Sub Categories", href: "/mutualfunds/sub-categories" },
//         ],
//       },
//       {
//         name: "Income",
//         icon: BsPiggyBank,
//         href: "#",
//         values: [
//           { name: "Categories", href: "/income/income-categories" },
//           { name: "Heads", href: "/income/income-heads" },
//         ],
//       },
//       { name: "ULIP Funds", href: "/product-master/ulip-funds" },
//       { name: "Bonds & Debenture Types", href: "/bonds-debenture" },
//       {
//         name: "Real Estate",
//         icon: BsPiggyBank,
//         href: "#",
//         values: [
//           { name: "Property Types", href: "/realstate/property-type" },
//           { name: "Ownership Status", href: "/realstate/ownership-status" },
//         ],
//       },
//       {
//         name: "Household",
//         icon: BsPiggyBank,
//         href: "#",
//         values: [
//           { name: "Categories", href: "/household/household-categories" },
//           { name: "Assets", href: "/household/household-assets" },
//           // { name: "Vehicles", href: "/household/household-vehicles" },
//         ],
//       },
//       {
//         name: "Bank",
//         href: "#",
//         values: [{ name: "Loan Types", href: "/bank/loan-type" }],
//       },
//       {
//         name: "Global Product Parameters",
//         href: "/product-master/global-product-parameter",
//       },
//       {
//         name: "Establishments",
//         href: "#",
//         values: [
//           {
//             name: "Establishment Types",
//             href: "/establishment/establishment-types",
//           },
//           {
//             name: "Insurance Companies",
//             href: "/establishment/insurance-companies",
//           },
//           { name: "Banks", href: "/establishment/establishment-bank" },
//           { name: "Branch", href: "/establishment/establishment-branch" },
//           // { name: "Financial Institutions", href: "/establishment/establishment-financial-institution" },
//           {
//             name: "Depository Participants",
//             href: "/establishment/establishment-depository-participants",
//           },
//           { name: "Mutual Fund AMCs", href: "/establishment/mutual-fund" },
//         ],
//       },
//       {
//         name: "Product Parameters",
//         href: "#",
//         values: [
//           // { name: "Fixed Return And Retirement Products", href: "" },
//           {
//             name: "Insurance Products",
//             href: "/product-parameter/insurance-product",
//           },
//           { name: "Mutual Funds", href: "/product-parameter/mutual-funds" },
//           { name: "Shares", href: "product-parameter/shares" },
//         ],
//       },
//     ],
//   },
//   {
//     name: "HR",
//     icon: BsFileEarmarkBarGraph,
//     img: iconMisReport,
//     href: "",
//     current: false,
//     children: [{ name: "Employee", href: "/admin/employees" }],
//   },
//   {
//     name: "Operations",
//     icon: GrStatusInfo,
//     img: iconInfo,
//     current: false,
//     children: [
//       {
//         name: "MF Transactions Errors",
//         href: "/operations/mftransactionsErrors/mftransactions-mising-schemes",
//       },
//       {
//         name: "Shares Transactions Errors",
//         href: "/operations/shareTransaction/sharetransaction-error",
//       },
//       // { name: "Bulk NAV Import", href: "" },
//       // { name: "Bulk Share Price Import", href: "" },
//     ],
//   },
//   {
//     name: "MIS Reports",
//     icon: BsFileEarmarkBarGraph,
//     img: iconMisReport,
//     href: "",
//     current: false,
//     children: [
//       { name: "Advisor's Client", href: "/mis-report/Advisor-aua" },
//       // { name: 'Opening & Closing Prices', href: '#' },
//     ],
//   },
// ];

// //  Admin

// const navigationAdmin = [
//   {
//     name: "Dashboard",
//     icon: BiBarChartAlt2,
//     href: "/dashboard",
//     img: iconDashboard,
//   },
//   {
//     name: "Accounting",
//     icon: GrStatusInfo,
//     img: iconAccounting,
//     current: false,
//     children: [
//       { name: "Expenses Vouchers", href: "/accouting/expense-voucher" },
//       { name: "Vendor/Suppliers", href: "/vendorsupplier/vendor-supplier" },
//       { name: "AUA Calculation", href: "/accounting/aua-calculation" },
//       { name: "Client Invoice Address", href: "/accounting/client-address" },
//       {
//         name: "Invoice",
//         href: "/accounting/invoice",
//         removeKey: "ADMIN_INVOICE_TAB",
//       },
//       {
//         name: "Company Bank Accounts",
//         href: "/accounting/company-bank-account",
//       },
//     ],
//   },
//   {
//     name: "Actions",
//     icon: BsFileEarmarkBarGraph,
//     img: iconAction,
//     href: "",
//     current: false,
//     children: [
//       { name: "Tasks", href: "/actions", removeKey: "ADMIN_ASSIGN_TASK_TAB" },
//       {
//         name: "Minutes of Meeting",
//         href: "/action/minutes-of-meeting",
//         removeKey: "SENT_FOR_REVIEW_TAB",
//       },
//       { name: "Document Tracker", href: "/actions/document-tracker" },
//     ],
//   },
//   {
//     name: "MIS Reports",
//     icon: BsFileEarmarkBarGraph,
//     img: iconMisReport,
//     href: "/mis-report",
//     removeKey: "ADVICE_LOG_BOOK",

//   },
//   {
//     name: "Financial Planning",
//     icon: BsFileEarmarkBarGraph,
//     img: iconFinancialPlaning,
//     href: "",
//     current: false,
//     children: [
//       { name: "Financial Plans", href: "/financial-plans" },
//       { name: "Tax Plans", href: "#" },
//       {
//         name: "Client Portfolios",
//         href: "/financial-planing/client-portfolio",
//       },
//       { name: "Advice Request", href: "#" },
//       { name: "Proactive Advices", href: "#" },
//     ],
//   },
//   {
//     name: "Masters",
//     icon: BsFileEarmarkBarGraph,
//     img: iconMaster,
//     href: "",
//     current: false,
//     children: [
//       {
//         name: "Company Details",
//         href: "/master/master-company-master",
//         removeKey: "COMPANY_MASTER_TAB",
//       },
//       { name: "Mail Templates", href: "/master/mail-template" },
//       { name: "Advisor Goals", href: "/advisor-goals" },
//       { name: "Clients", href: "/clients" },
//       { name: "Fee Slab Master", href: "/slabs" },
//       {
//         name: "Planning Master",
//         icon: BsPiggyBank,
//         href: "#",
//         values: [
//           { name: "Assumptions", href: "/master/planning-assumption" },
//           {
//             name: "Model Portfolios",
//             href: "/master/planning-model-portfolio",
//           },
//           { name: "Comments", href: "/master/planning-comments" },
//           {
//             name: "Disclaimer And Disclosure ",
//             href: "/master/planning-disclaimer-discloser",
//           },
//           {
//             name: "Company Sign OFF Details ",
//             href: "/master/planning-sign-off-details",
//           },
//         ],
//       },
//       { name: "Mail Groups", href: "/master/planning-mailing-group" },
//       { name: "Announcements", href: "/master/announcements" },
//       {
//         name: "Recommendations",
//         icon: BsPiggyBank,
//         href: "#",
//         values: [
//           {
//             name: "Insurance Products ",
//             href: "/master/insurance-product-recommendation",
//           },
//           {
//             name: "Investment Products ",
//             href: "/master/recommendation-investment-product",
//           },
//         ],
//       },
//       { name: "Global Parameter", href: "/master/global-parameter" },
//     ],
//   },
//   {
//     name: "BD",
//     icon: GrStatusInfo,
//     img: iconBd,
//     current: false,
//     children: [{ name: "AUA Selection", href: "/admin/aua-selection" }],
//   },
//   {
//     name: "HR",
//     icon: GrStatusInfo,
//     img: iconHr,
//     current: false,
//     children: [{ name: "Employees", href: "/admin/employees" }],
//   },
//   {
//     name: "Operations",
//     icon: GrStatusInfo,
//     img: iconOperation,
//     current: false,
//     children: [
//       { name: "Fixed Income Transactions", href: "" },
//       { name: "Shares Transactions", href: "" },
//       { name: "MF Transactions", href: "" },
//       { name: "MF Systematic Transactions", href: "" },
//       { name: "MF Units Reconcliation", removeKey: "MF_UNITS_RECONCLIATION" },
//     ],
//   },
// ];

function classNames(...classes: any) {
  return classes.filter(Boolean).join(" ");
}

// function closeSideMenu() {
//   var element = document.getElementById("left_side_bar");
//   if (element != null) {
//     element.classList.add("hidden");
//   }

//   var element2 = document.getElementById("header_plus_content_container");
//   if (element2 != null) {
//     element2.classList.remove("blur-sm");
//   }
// }

export default function SpringMoneySideBar(props : any) {
  let history = useNavigate();

  const [navigation, setNavigation] = useState<any[]>([]);
  const dispatch: Dispatch<any> = useDispatch();
  const user_data = JSON.parse(localStorage.getItem("user_Detail") || "{}");

  // dispatch(setDataInRedux({ type: PAGINATION, value: null }));

  useEffect(() => {
    getLeftMenuList();
  }, []);

  const notWithRTA = () => {
    WebService.postAPI({
      action: `/v2/UnitsReconciliationReport/Count`,
      body: null,
    })
      .then((res: any) => {
        if (res.match_count || res.unmatch_count) {
          history("/admin/operation/unit-reconciliation-unmatched");
        }
        if (res.match_count == "0" || res.unmatch_count == "0") {
          history("/admin/operation/import-unit-reconciliation");
        }
      })
      .catch((e) => { });
  };

  const onRemove = (value: any) => {
    localStorage.removeItem("openTab");
    if (value == "ADMIN_INVOICE_TAB") {
      dispatch(setDataInRedux({ type: ADMIN_INVOICE_TAB, value: null }));
    }
    if (
      value == "ADMIN_ASSIGN_TASK_TAB" ||
      value == "ADMIN_MY_TASK_TAB" ||
      value == "MANAGER_TAB"
    ) {
      dispatch(setDataInRedux({ type: ADMIN_ASSIGN_TASK_TAB, value: null }));
      dispatch(setDataInRedux({ type: ADMIN_MY_TASK_TAB, value: null }));
      dispatch(setDataInRedux({ type: MANAGER_TAB, value: null }));
    }
    if (value == "SYSTEMATIC_PLAN_TAB") {
      dispatch(setDataInRedux({ type: SYSTEMATIC_PLAN_TAB, value: null }));
      dispatch(setDataInRedux({ type: SHARE_TAB, value: null }));
    }
    if (value == "ADVICE_LOG_BOOK") {
      dispatch(setDataInRedux({ type: ADVICE_LOG_BOOK, value: null }));
    }
    if (value == "SENT_FOR_REVIEW_TAB") {
      dispatch(setDataInRedux({ type: SENT_FOR_REVIEW_TAB, value: null }));
    }
    if (value == "COMPANY_MASTER_TAB") {
      dispatch(setDataInRedux({ type: COMPANY_MASTER_TAB, value: null }));
    }
    if (value == "MF_UNITS_RECONCLIATION") {
      notWithRTA();
    }
  };

  const onRemoveKey = (value: any) => {
    localStorage.removeItem("openTab");
    if (value == "SYSTEMATIC_PLAN_TAB") {
      dispatch(setDataInRedux({ type: SYSTEMATIC_PLAN_TAB, value: null }));
      dispatch(setDataInRedux({ type: SHARE_TAB, value: null }));
    }
  };

  const getImageStyle = (value: any) => {
    if (value == "iconDashboard") {
      return iconDashboard;
    }
    if (value == "iconInfo") {
      return iconInfo;
    }
    if (value == "iconPortfolio") {
      return iconPortfolio;
    }
    if (value == "iconGolas") {
      return iconGolas;
    }
    if (value == "iconExpenses") {
      return iconExpenses;
    }
    if (value == "iconinsurance") {
      return iconinsurance;
    }
    if (value == "iconAction") {
      return iconAction;
    }
    if (value == "iconPlaning") {
      return iconPlaning;
    }
    if (value == "iconMisReport") {
      return iconMisReport;
    }
    if (value == "iconAccounting") {
      return iconAccounting;
    }
    if (value == "iconFinancialPlaning") {
      return iconFinancialPlaning;
    }
    if (value == "iconBd") {
      return iconBd;
    }
    if (value == "iconHr") {
      return iconHr;
    }
    if (value == "iconOperation") {
      return iconOperation;
    }
    if (value == "iconMaster") {
      return iconMaster;
    }
    if (value == "iconInfo") {
      return iconInfo;
    }
    if (value == "iconInfo") {
      return iconInfo;
    }
  };

  const getLeftMenuList = () => {
    WebService.getAPI({
      action: `/v2/UserProfile/MenuList`,
      body: null,
    })
      .then((res: any) => {
        for (var i in res.final_menues) {
          if (res.final_menues[i].react_url == "/mis-report") {
            res.final_menues[i].children = [];
          }
          if (res.final_menues[i].react_url == "/dashboard") {
            res.final_menues[i].children = [];
          }
          if (res.final_menues[i].react_url == "/reports") {
            res.final_menues[i].children = [];
          }
          if (res.final_menues[i].react_url == "/portfolio") {
            res.final_menues[i].children = [];
          }

          if (user_data.is_person == "Admin") {
            for (var j in res.final_menues[i].children) {
              if (
                res.final_menues[i].children[j].react_url ==
                "/master/mail-template"
              ) {
                res.final_menues[i].children[j].href = "/mail-template";
              }
            }
          }
        }
        console.log('res from menu list......', res)
        setNavigation(res.final_menues);
      })
      .catch((e) => { });
  };

  const [selectedCat, SetSelectedCat] = useState<string>("Dashboard");
  const [selectedSubCat, SetSelectedSubCat] = useState<string>();
  const [selectedSubChildCat, SetSelectedSubChildCat] = useState<string>();

  const handleSelectedCat = (name: string) => {
    SetSelectedCat(name);
  };

  const handleSelectedSubCat = (name: string) => {
    SetSelectedSubCat(name);
  };

  const handleSelectedSubChildCat = (name: string) => {
    SetSelectedSubChildCat(name);
  };

  const closeSideMenu = () =>{
    props.setIsSidebarVisible(false);
  }

  return (
    <>
      <div className="md:inset-y-0 md:flex md:w-[100%] md:h-[1200px] left-sidebar">
        <div className="flex flex-grow flex-col overflow-y-auto p-[16px] bg-white md:h-screen">
          <div className="mb-[16px] flex justify-between">
            <div className=" font-sans font-semibold">
              <span>{user_data.name ? user_data.name : "-"}</span>
            </div>
            <div className="">
              <a
                href="javascript:void(0)"
                className=" "
                onClick={closeSideMenu}
              >
                <img src="/images/close.svg" width={25} className="" />
              </a>
            </div>
          </div>
          <div className=" flex flex-grow flex-col">
            <nav
              className="flex-1 space-y-[8px] bg-white left-mebu"
              aria-label="Sidebar"
            >
              {navigation.length > 0 &&
                navigation.map((item) =>
                  !item.children || item.children.length <= 0 ? (
                    <div
                      key={item.name}
                      className=" "
                    // title={item.name}
                    >
                      <NavLink
                        to={item.href}
                        onClick={() => {
                          onRemoveKey(item.removeKey);
                          handleSelectedCat(item.name);
                          handleSelectedSubCat("");
                          handleSelectedSubChildCat("");
                          props.setIsSidebarVisible(false);
                        }}
                        // onClick={() => { localStorage.removeItem('openTab') }}
                        className={`${selectedCat === item.name ? 'bg-[#7B5AEC] text-white' : 'text-gray-900'}  group w-full flex items-center border-[0.5px] px-[16px] py-[8px] text-[13px] font-medium rounded-md`}
          
                      >
                        <img
                          src={getImageStyle(item.icon)}
                          className="mr-[10px] flex-shrink-0 h-6 w-6 menu-icon"
                        />
                        <span
                          className={`menu-name ${selectedCat === item.name ? "font-semibold" : ""
                            }`}
                        >
                          {item.name}
                        </span>
                      </NavLink>
                    </div>
                  ) : (
                    <Disclosure
                      as="div"
                      key={item.name}
                      className=""
                    // title={item.name}
                    >
                      {({ open }) => (
                        <>
                          <Disclosure.Button
                            className={`group w-full flex items-center border-[0.5px] px-[16px] py-[8px] text-left text-[13px] font-medium rounded-md 
                          ${selectedCat === item.name ? "bg-[#7B5AEC]" : ""}`}
                          >
                            <img
                              src={getImageStyle(item.icon)}
                              className="mr-[10px] flex-shrink-0 h-6 w-6 menu-icon"
                            />

                            <span
                              className={`flex-1 menu-name ${selectedCat === item.name
                                  ? "font-semibold text-[#FFFFFF]"
                                  : ""
                                }`}
                            >
                              {item.name}
                            </span>
                            <BiChevronRight
                              size={20}
                              className={classNames(
                                open
                                  ? "text-[#7C7C7C] rotate-90"
                                  : "text-[#7C7C7C]",
                                `${selectedCat === item.name
                                  ? "text-[#ffffff]"
                                  : ""
                                } ml-3 h-5 w-5 flex-shrink-0 transform transition-colors duration-150 ease-in-out`
                              )}
                            />
                          </Disclosure.Button>

                          <Disclosure.Panel className=" bg-[#F8F8F8]  submenu-item ">
                            {item.children.map((subItem: any) => (
                              <>
                                {subItem.children &&
                                  subItem.children.length > 0 ? (
                                  <Disclosure
                                    as="div"
                                    key={subItem.name}
                                    className=""
                                  >
                                    {({ open }) => (
                                      <>
                                        <Disclosure.Button
                                          className={`group w-full flex items-center border-[0.5px] px-[16px] py-[8px] text-left text-[13px] font-medium  
                                        ${selectedSubCat === subItem.name
                                              ? "bg-[#E5EEFF]"
                                              : ""
                                            }`}
                                        >
                                          <span
                                            className={`flex-1 menu-name ${selectedSubCat === subItem.name
                                                ? "font-semibold  text-[#7B5AEC]"
                                                : ""
                                              }`}
                                          >
                                            {subItem.name}
                                          </span>
                                          <BiChevronRight
                                            size={20}
                                            className={classNames(
                                              open
                                                ? "text-[#7C7C7C] rotate-90"
                                                : "text-[#7C7C7C]",
                                              "ml-3 h-5 w-5 flex-shrink-0 transform transition-colors duration-150 ease-in-out"
                                            )}
                                          />
                                        </Disclosure.Button>

                                        <Disclosure.Panel className=" submenu-item second-level">
                                          {subItem.children.map((res: any) => (
                                            <NavLink
                                              key={res.name}
                                              to={res.href}
                                              onClick={() => {
                                                onRemove(res.removeKey);
                                                handleSelectedCat(item.name);
                                                handleSelectedSubCat(
                                                  subItem.name
                                                );
                                                handleSelectedSubChildCat(
                                                  res.name
                                                );
                                                props.setIsSidebarVisible(false);
                                              }}
                                              className={`group flex w-full items-center  border-[0.5px] px-[16px] py-[8px] pl-[32px] text-[13px] 
                                              ${selectedSubChildCat === res.name
                                                  ? "text-[#7B5AEC] font-semibold border-l-[5px] border-l-[#7B5AEC]"
                                                  : " font-normal text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                                                }`}
                                            >
                                              {res.name}
                                            </NavLink>
                                          ))}
                                        </Disclosure.Panel>
                                      </>
                                    )}
                                  </Disclosure>
                                ) : (
                                  <NavLink
                                    key={subItem.name}
                                    to={subItem.href}
                                    onClick={() => {
                                      onRemove(subItem.removeKey);
                                      handleSelectedCat(item.name);
                                      handleSelectedSubCat(subItem.name);
                                      handleSelectedSubChildCat("");
                                      props.setIsSidebarVisible(false);
                                    }}
                                    className={`group flex w-full items-center border-[0.5px]  px-[16px] py-[8px] text-[13px]
                                    ${selectedSubCat === subItem.name
                                        ? "bg-[#E5EEFF] text-[#7B5AEC] font-semibold"
                                        : " font-normal text-gray-600  hover:text-gray-900"
                                      }`}
                                  >
                                    {subItem.name}
                                  </NavLink>
                                )}
                              </>
                            ))}
                          </Disclosure.Panel>
                        </>
                      )}
                    </Disclosure>
                  )
                )}
            </nav>
          </div>
        </div>
      </div>
    </>
  );
}
